const move = (data) => {
  return {
    departName: {
      label: "组织名称：",
      formType: "a-span",
      value: data.departName
    },
    departmentId: {
      label: "隶属部门：",
      formType: "a-depart-select",
      value: data.id,
      placeholder: "请选择隶属部门",
      rules: [{
        required: true,
        message: "请选择隶属部门",
        trigger: "blur"
      }]
    }
  }
}

const add = {
  departName: {
    label: "名称：",
    formType: "a-input",
    value: undefined,
    placeholder: "请输入职位名称",
    rules: [{
      required: true,
      message: "请输入职位名称",
      trigger: "blur"
    }]
  },
  code: {
    label: "编码：",
    formType: "a-input",
    value: undefined,
    placeholder: "请输入编码"
  },
  crewSize: {
    label: "编制：",
    formType: "a-input-number",
    value: undefined,
    placeholder: "请输入编制"
  },
  type: {
    label: "类别：",
    formType: "a-select",
    value: undefined,
    placeholder: "请选择类别",
    code: 109,
    rules: [{
      required: true,
      message: "请选择类别",
      trigger: "blur"
    }]
  }
}

const edit = (data) => {
  return {
    departName: {
      label: "名称：",
      formType: "a-input",
      value: data.departName,
      placeholder: "请输入职位名称",
      rules: [{
        required: true,
        message: "请输入职位名称",
        trigger: "blur"
      }]
    },
    code: {
      label: "编码：",
      formType: "a-input",
      value: data.code,
      placeholder: "请输入编码"
    },
    crewSize: {
      label: "编制：",
      formType: "a-input-number",
      value: data.crewSize,
      placeholder: "请输入编制"
    },
    type: {
      label: "类别：",
      formType: "a-select",
      value: data.type,
      placeholder: "请选择类别",
      code: 109,
      rules: [{
        required: true,
        message: "请选择类别",
        trigger: "blur"
      }]
    }
  }
}

export default {
  move,
  add,
  edit
}



// WEBPACK FOOTER //
// ./src/components/OATree/formData.js